export const tools_CreateContent = [
	{
		icon: '⭐️',
		subtitle: 'toolsData.subtitle1',
	},
	{
		icon: '🖼',
		subtitle: 'toolsData.subtitle2',
	},
	{
		icon: '💁‍♀️',
		subtitle: 'toolsData.subtitle3',
	},
];
